import {
	Airplay,
	Award,
	Edit,
	Edit3,
	Home,
	Image,
	Inbox,
	Info,
	Monitor,
	Phone,
	Slash,
	User,
	UserPlus,
	Users,
} from "react-feather";

const navLinks = [
	{
		route: "/",
		text: "Home",
		icon: <Home />,
	},
	{
		route: "/about",
		text: "About",
		icon: <Info />,
	},
	{
		route: "/events",
		text: "Events",
		icon: <Airplay />,
	},
	{
		route: "/gallery",
		text: "Gallery",
		icon: <Image />,
	},
	{
		route: "/team",
		text: "Team",
		icon: <User />,
	},
	{
		route: "/notable-alumni",
		text: "Notable Alumni",
		icon: <Award />,
	},
	{
		route: "/admin",
		text: "Admin Panel",
		icon: <Monitor />,
	},
	{
		route: "/contact",
		text: "Contact Us",
		icon: <Phone />,
	},
];

const otherNavLinks = [
	{
		route: "/forms/apply",
		text: "Apply to join",
		icon: <UserPlus />,
	},
	{
		route: "/forms/add-member-details",
		text: "Add Member Details",
		icon: <UserPlus />,
	},
	{
		route: "/admin/members",
		text: "Team Members",
		icon: <Users />,
	},
	{
		route: "/admin/write",
		text: "Write A Blog",
		icon: <Edit />,
	},
	{
		route: "/admin/applications",
		text: "Applications",
		icon: <Inbox />,
	},
];

export default navLinks;

export const getRouteTitle = (route) => {
	if (route.slice(0, 6) === "/blog/") return "Blog";
	for (let routeObj of navLinks) {
		if (routeObj.route === route) {
			return routeObj.text;
		}
	}
	for (let routeObj of otherNavLinks) {
		if (routeObj.route === route) {
			return routeObj.text;
		}
	}
	return "404";
};

export const getRouteIcon = (route) => {
	if (route.slice(0, 6) === "/blog/") return <Edit3 />;
	for (let routeObj of navLinks) {
		if (routeObj.route === route) {
			return routeObj.icon;
		}
	}
	for (let routeObj of otherNavLinks) {
		if (routeObj.route === route) {
			return routeObj.icon;
		}
	}
	return <Slash />;
};
